import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { createCrudTableService } from '@/components/business/crud/service/CrudTableService';
import WidgetTableBody from '@/components/business/crud/table/WidgetTableBody.vue';
import WidgetTablePagination from '@/components/business/crud/table/WidgetTablePagination.vue';
import WidgetTableButton from '@/components/business/crud/table/WidgetTableButton.vue';
import { message, Modal } from 'ant-design-vue';
import { windows } from '@/components/common/window/Windows';
import { ref, shallowRef, watch } from 'vue';
import WidgetSearch from '@/components/business/crud/form/WidgetSearch.vue';
import { createSearchService } from '@/components/business/crud/service/CrudSearchService';
import WidgetSearchBtn from '@/components/business/crud/form/WidgetSearchBtn.vue';
import SelectModelDialog from '@/components/business/crud/common/SelectModelDialog.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModelTable',
  props: {
    title: {},
    status: { default: 'show' },
    moduleName: {},
    controllerName: {},
    labelName: { default: 'name' },
    condition: {},
    attachCondition: {},
    hiddenFields: { default: () => [] },
    onChange: {}
  },
  setup(__props: any) {

const props = __props;
const showSearch = ref(false);
const searchService = createSearchService(
  props.moduleName,
  props.controllerName
);

const { form, groups, getCondition } = searchService.use();

const service = createCrudTableService(props.moduleName, props.controllerName);
service.listConfig.pageSize = 10;
const {
  listData,
  columns,
  buttons,
  rowSelection,
  schema,
  onChange: onOrderChange,
} = service.use();

function onSearch() {
  service.listConfig.condition = {
    $and: [props.condition, getCondition()],
  };
}

searchService.init().then(() => {
  onSearch();
  service.widgetContainer.delField(...props.hiddenFields);
  service.init();
  service.widgetContainer.hideButtonsExclude('view', 'refresh');
  // 添加按钮
  service.widgetContainer.addButton('attach', {
    type: 'table',
    icon: 'PlusOutlined',
    text: '添加',
    handler: async () => {
      const id = windows.open({
        content: {
          type: 'component',
          component: shallowRef(SelectModelDialog),
          props: {
            moduleName: props.moduleName,
            controllerName: props.controllerName,
            labelName: props.labelName,
            condition: props.attachCondition,
          },
        },
        title: '添加' + props.title,
        width: 1280,
        height: 800,
      });
      const selected = await windows.getCloseData(id);
      if (!props.onChange) {
        return;
      }
      const res = await props.onChange('attach', selected);
      if (res) {
        message.success('添加成功');
        await service.refreshList();
      }
    },
  });
  // 移除按钮
  service.widgetContainer.addButton('detach', {
    type: 'row',
    text: '移除',
    confirm: '确定要移除此' + props.title,
    hidden: () => props.status === 'show',
    handler: async (row: any) => {
      if (!props.onChange) {
        return;
      }
      const res = await props.onChange('detach', [row]);
      // 通过父组件删除
      if (res) {
        message.success('移除成功');
        await service.refreshList();
      }
    },
  });
  // 批量移除按钮
  service.widgetContainer.addButton('detachSelect', {
    type: 'select',
    icon: 'DeleteOutlined',
    text: '移除',
    handler: async (rows: any[]) => {
      if (rows.length === 0) {
        message.info('未选中任何项');
        return;
      }
      Modal.confirm({
        title: '确定要移除这' + rows.length + '项吗？',
        onOk: async () => {
          if (!props.onChange) {
            return;
          }
          const res = await props.onChange('detach', rows);
          if (res) {
            message.success('移除成功');
            await service.refreshList();
          }
        },
      });
    },
  });
  watch(
    () => props.status,
    (value) => {
      if (value === 'edit' && props.onChange) {
        service.widgetContainer.showButtons('detach', 'detachSelect');
        if (props.attachCondition) {
          service.widgetContainer.showButtons('attach');
        }
      } else {
        service.widgetContainer.hideButtons('attach', 'detach', 'detachSelect');
      }
    },
    { immediate: true }
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(WidgetSearch, {
      form: _unref(form),
      groups: _unref(groups),
      onSearch: onSearch,
      show: showSearch.value
    }, null, 8, ["form", "groups", "show"]),
    _createVNode(WidgetTableButton, { buttons: _unref(buttons) }, {
      default: _withCtx(() => [
        _createVNode(WidgetSearchBtn, {
          modelValue: showSearch.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showSearch).value = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["buttons"]),
    _createVNode(WidgetTableBody, {
      onChange: _unref(onOrderChange),
      columns: _unref(columns),
      "list-data": _unref(listData),
      "row-selection": _unref(rowSelection),
      "select-row-key": _unref(schema).primary
    }, null, 8, ["onChange", "columns", "list-data", "row-selection", "select-row-key"]),
    _createVNode(WidgetTablePagination, {
      count: _unref(listData).count,
      "page-num": _unref(service).listConfig.pageNum,
      "onUpdate:pageNum": _cache[1] || (_cache[1] = ($event: any) => ((_unref(service).listConfig.pageNum) = $event)),
      "page-size": _unref(service).listConfig.pageSize,
      "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_unref(service).listConfig.pageSize) = $event))
    }, null, 8, ["count", "page-num", "page-size"])
  ]))
}
}

})